// Minimal fallback structure when no policy is provided from database
// Actual policy text should always come from the API via course_policies table
export const DEFAULT_GROUP_POLICY = {
  id: 1,
  name: 'group',
  display_name: 'Group',
  description: null,
  description_kr: null
};
